import {
  ClearingSaleBuyerStatus,
  ClearingSaleBuyerStatusOrder,
} from "constants/clearingSaleAttributes";
import { PaymentMethod } from "constants/payments";

export const ALL_STATUSES = "ALL_STATUSES";

export type StatusFilterValue = typeof ALL_STATUSES | ClearingSaleBuyerStatus;

export function getStatusFilter(
  value: StatusFilterValue,
): (buyerStatus: ClearingSaleBuyerStatus) => boolean {
  if (value === ALL_STATUSES) {
    return () => true;
  }
  return buyerStatus => buyerStatus === value;
}

// An empty selection means no filtering - matches every buyer.
export function getPaymentMethodFilter(
  selectedMethods: readonly PaymentMethod[],
): (buyerPaymentMethods: readonly PaymentMethod[]) => boolean {
  if (selectedMethods.length === 0) {
    return () => true;
  }
  return buyerPaymentMethods =>
    buyerPaymentMethods.some(method => selectedMethods.includes(method));
}

// Ordered to match the flow of a sale (Sold -> Part Paid -> On Account -> Paid), not enum declaration order.
export const statusFilterValues: readonly StatusFilterValue[] = [
  ALL_STATUSES,
  ...ClearingSaleBuyerStatusOrder,
];
